import { useUserSitePreferences } from '@ukpostbox/client-data';
import {
	Card,
	CardLayoutType,
	ContentBlock,
	ContentLoader,
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import { AutoForwarding } from '../../Components/AutoForwarding';
import UserAction from '../../Components/Controls/UserAction';
import { SettingsActionType } from '../../Types/SettingsTypes';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

type UserPreferencesType = {
	userActions: Array<SettingsActionType>;
};

function Preferences() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();
	const formMethods = useForm();

	const {
		status,
		data,
		error,
	}: {
		status: any;
		data: any | UserPreferencesType;
		error: any;
		isFetching: any;
	} = useUserSitePreferences();

	useEffect(() => {
		updatePageMeta({
			title: t('settings.preferences.title'),
		});
	}, [currentLocale]);

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-md'>
				<h2 className='mb-0'>{t(`settings.sections.${'Preferences'}`)}</h2>
			</StackHorizontal>

			<FormProvider {...formMethods}>
				<StackVertical gap={FlexGap.ExtraLarge}>
					<div>
						<Card header={{ title: t('labels.general') }} type={CardLayoutType.SlimHeader} emptyBody>
							{status === 'pending' ? (
								<ContentLoader childHeight='6em' childCount={6} />
							) : status === 'error' ? (
								<ContentBlock error title={error.name} content={error.message} />
							) : (
								data &&
								data.userActions.map((item: SettingsActionType) => (
									<UserAction {...item} key={`preferencesUserAction${item.label}`} />
								))
							)}
						</Card>
					</div>

					<div>
						<AutoForwarding />
					</div>
				</StackVertical>
			</FormProvider>
		</>
	);
}

export default Preferences;
